import { EVENT_FILTER_GROUPS } from './calendar-events';

const CALENDAR_FILTER_GROUP_ORDER = [
  'academic_calendar',
  'events',
  'reviews',
  'affiliations',
  'audiences',
];
const CALENDAR_FILTER_GROUP_RANK = new Map(
  CALENDAR_FILTER_GROUP_ORDER.map((groupId, index) => [groupId, index])
);

export const calendarFilterGroups = [
  {
    id: 'academic_calendar',
    title: 'Academic Calendar',
    allLabel: 'All Academic Calendar',
    options: EVENT_FILTER_GROUPS['Academic Calendar'],
  },
  {
    id: 'events',
    title: 'Events',
    allLabel: 'All Events',
    options: EVENT_FILTER_GROUPS.Events,
  },
  {
    id: 'reviews',
    title: 'Reviews',
    allLabel: 'All Reviews',
    options: EVENT_FILTER_GROUPS.Reviews,
  },
  {
    id: 'affiliations',
    type: 'affiliations',
    title: 'Affiliations',
    allLabel: 'All Affiliations',
    options: [],
  },
  {
    id: 'audiences',
    title: 'Audiences',
    allLabel: 'All Audiences',
    options: [],
  },
];

/**
 * Return Calendar filter groups in the product display order.
 */
export function orderCalendarFilterGroups(filterGroups = []) {
  return [...filterGroups].sort((a, b) => {
    return filterGroupRank(a) - filterGroupRank(b);
  });
}

function filterGroupRank(group) {
  return CALENDAR_FILTER_GROUP_RANK.get(group.id) ?? CALENDAR_FILTER_GROUP_ORDER.length;
}
